import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/useAuth";
import { decodeJwt } from "../utils/decodeJwt";

export function AdminRoute({ children }) {
  const { token, isAdmin } = useAuth();

  const exp = decodeJwt(token)?.exp;
  if (!token || (exp && exp * 1000 <= Date.now())) {
    return <Navigate to="/" replace />;
  }

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return children;
}